const calculateDepositInterest = (ir, np, amount) => {
  return (amount * np * (ir / 100)) / 12;
};

/**
 *
 * @param {number} ir interest rate
 * @param {number} np number of months
 * @param {number} amount Amount set in deposit
 * @returns
 */
export const calculateDepositReceiveable = (_ir, _np, _amount) => {
  const ir = parseFloat(_ir);
  const np = parseFloat(_np);
  const amount = parseFloat(_amount);

  const interest = calculateDepositInterest(ir, np, amount);

  return {
    interestAmount: interest,
    totalAmount: amount + interest,
  };
};
